module.exports = __webpack_public_path__ + "img/2.cb5b1b59.jpg";